import service from "../services/AppService";

class AppApi {
    getDownloadBrowsersInfo () {
        return new Promise((resolve, reject) => {
            service.getDownloadBrowsersInfo()
                .then((res) => resolve(res.data))
                .catch((error) => reject(error));
        });
    }
}

export default new AppApi();
